exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-06af34be],\n.fade-leave-active[data-v-06af34be] {\n    transition: opacity 0.3s ease;\n}\n.fade-enter-from[data-v-06af34be],\n.fade-leave-to[data-v-06af34be] {\n    opacity: 0;\n}\n", ""]);

// exports
